export default __webpack_public_path__ + "static/media/TTATransparentGirlImg.adfd5a68.png";